import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';
import Typography from '@mui/material/Typography';

const ProgressModal = (props) => {
  const { progressValue } = props;
  return (
    <Box display="flex" alignItems="center">
      <Box width="100%" mr={1}>
        <LinearProgress variant="determinate" value={progressValue} />
      </Box>
      <Box minWidth={35}>
        <Typography variant="body2" color="textSecondary">
          {`${progressValue}%`}
        </Typography>
      </Box>
    </Box>
  );
};

ProgressModal.defaultProps = {
  progressValue: 0,
};

ProgressModal.propTypes = {
  progressValue: PropTypes.number,
};

const mapStateToProps = ({ modal: { progressValue } }, { id }) => ({
  progressValue: progressValue?.[id] ?? 0,
});
const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(ProgressModal);
